<template>
    <div class="dialog-mask">
        <div :class="mode === 'full' ? 'dialog-container-full' : 'dialog-container'">
            <div class="dialog-header_container" :style="mode === 'full' && 'padding:0;'">
                <slot name="header">
                    <div class="dialog-header_title">{{title}}</div>
                    <i v-if="closeable" class="fa fa-close close-button" @click="onClose" />
                </slot>
                <!-- 2022.01.13 下面关闭按钮为：实名可跳过 按钮 -->
                <div
                    class="dialog-header_close_btn"
                    role="button"
                    v-show="showCloseButton"
                    @click="handleCloseClick"
                >
                    ×
                </div>
                <!-- 2022.01.13 下面关闭按钮为：强制实名 按钮 -->
                <div
                    class="dialog-header_close_btn"
                    style="color:red"
                    role="button"
                    v-show="showLoginOutButton"
                    @click="handleLoginOutClick"
                >
                    ×
                </div>
            </div>
            <div class="dialog-body_container" :style="mode === 'full' && 'padding:0;font-size:0;'">
                <slot></slot>
            </div>
            <div class="dialog-footer_container">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'H5Dialog',
    props: {
        title: {
            default: '',
            type: String,
        },
        showCloseButton: {
            default: false,
            type: Boolean
        },
        showLoginOutButton: {
            default: false,
            type: Boolean
        },
        mode: {
            default: 'normal', // normal, full(无边框大屏显示)
            type: String
        },
        closeable: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        handleCloseClick() {
            this.$emit('close')
        },
        handleLoginOutClick() {
            this.$emit('close-bind-id-modal')
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>

<style scoped lang="scss">
    .dialog-mask {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, .32);
    }

    .dialog-container {
        min-height: 30vh;
        height: max-content;
        border-radius: var(--radius-size-lg);
        overflow: hidden;
        background-color: $white;
        margin: auto;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        box-sizing: border-box;
        padding: 0 18px;
    }

    @media screen and (orientation: portrait) {
        .dialog-container {
            width: 90vw;
        }

        .dialog-container-full {
            width: 91vw; // 2022.07.07 抵消 iOS设备上的1像素白边条
        }

        .dialog-body_container {
            max-height: 80vh;
        }
    }

    @media screen and (orientation: landscape) {
        .dialog-container {
            width: 90vh;
        }

        .dialog-container-full {
            width: 91vh; // 2022.07.07 抵消 iOS设备上的1像素白边条
        }

        .dialog-body_container {
            max-height: 60vh;
        }
    }

    .dialog-header_container,
    .dialog-body_container,
    .dialog-footer_container {
        position: relative;
        padding: 8px;
        box-sizing: border-box;
    }

    .dialog-header_container:empty,
    .dialog-body_container:empty,
    .dialog-footer_container:empty {
        display: none;
    }

    .dialog-header_container {
        display: flex;
        flex-direction: row;
        /*border-bottom: 1px solid #ebf2fc;*/
        line-height: 32px;
    }

    .dialog-header_title {
        flex: 1;
        text-align: center;
        font-size: 18px;
        position: relative;
    }

    .dialog-body_container {
        overflow: auto;
    }

    .dialog-header_close_btn {
        position: absolute;
        right: 0;
        top: 0;
        line-height: 1;
        padding: 8px 16px;
        font-size: 30px;
        color: $themeColor;
    }

    .close-button {
        position: absolute;
        right: 10px;
        top: 6px;
        z-index: 99999;
        font-size: 36px;
        color: #999;
    }

    .dialog-container-full {
        padding: 0;
        border-radius: 0;
        background-color: transparent;
        min-height: 30vh;
        height: max-content;
        overflow: hidden;
        margin: auto;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        box-sizing: border-box;
    }

</style>
